module.exports = __webpack_public_path__ + "assets/3a4648d21ca583efcd3c68a060dfc1bc.png";